module.exports = "/images/bo.svg?8f857685bbb898870c85ae6303ce8ddc";